import { Trans } from '@lingui/react/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useAttachments } from '../../Provider';
export function Dropdown(props) {
    const { origin, onUpload, onSelect } = props;
    const { disableAdd, uploadingAttachment } = useAttachments();
    const disabled = disableAdd || uploadingAttachment;
    const handleSelect = () => {
        onSelect();
    };
    const handleUpload = () => {
        onUpload();
    };
    const emptyStateButton = (<Button appearance="primary" size="small" disabled={disabled}>
      <Falcon icon="plus"/>
      <Trans comment="No attachments added empty state - add attachment label">Add</Trans>
    </Button>);
    const listActionButton = (<Button appearance="secondary" size="small" disabled={disabled}>
      <Falcon icon="plus"/>
      <Trans comment="Add attachment button label">Add</Trans>
    </Button>);
    const target = origin === 'emptyState' ? emptyStateButton : listActionButton;
    return (<Menu.Root target={target}>
      <Menu.Item onClick={handleSelect}>
        <Falcon icon="folder"/>
        <Trans comment="Select document on miramis button label">Select on Miramis</Trans>
      </Menu.Item>
      <Menu.Item onClick={handleUpload}>
        <Falcon icon="up-from-bracket"/>
        <Trans comment="Upload document button label">Upload document</Trans>
      </Menu.Item>
    </Menu.Root>);
}
